import normalize from 'jsonapi-normalizer'

import {
  buildAsyncAction,
} from 'containers/Async/actions'
import {
  asyncReduxFilter,
} from 'containers/Async/actions'
import {
  clearTables,
  updateTables,
} from 'containers/Entity/actions'
import {
  getProjectDetails as getDetailsAction,
  getWorkflowDetails as getWorkflowAction,
  getProjectFormUrl,
  setFormStatus,
} from 'containers/Project/actions'
import {
  UPDATE_PROJECT_INFO,
  UPDATE_PROJECT_WORKFLOW,
  CLEAR_PROJECT_INFO,
  LOAD_FORM_DATA,
  TOGGLE_COLLAPSE,
  CLONE_PROJECT,
  POST_CANCEL_PROJECT,
  POST_CANCEL_PROJECT_START,
  POST_CANCEL_PROJECT_SUCCESS,
  POST_CANCEL_PROJECT_ERROR,
  SCROLL_TOP,
} from './constants'
import {
  FORM_STATUS
} from 'containers/Project/constants'
import {
  workflowIdSelector,
  productHierarchyIdSelector,
  productClassTypeIdSelector,
  partnerSiteIdSelector,
} from './selectors'
import {
  clearUiState,
  setIsLoaded,
  resetIsLoaded,
  loadProjectFormData,
} from 'containers/Project/actions'
import {
  getProjectInfoAction,
  createProjectAction
} from 'containers/Project/Overview/actions'
import {
  setRedirect,
} from 'containers/ProjectCreatePage/actions'
import {
  error
} from 'containers/App/Notification/actions'

import {
  projectScheduleSelector
} from '../ScheduleSection/selectors'

const toggleCollapse = () => {
  return {
    type: TOGGLE_COLLAPSE,
  }
}

const clearProjectInfo = () => {
  return {
    type: CLEAR_PROJECT_INFO
  }
}

const updateProjectInfo = ({key, value}) => {
  return {
    type: UPDATE_PROJECT_INFO,
    key,
    value
  }
}

const updateProjectWorkflow = ({key, value}) => {
  return {
    type: UPDATE_PROJECT_WORKFLOW,
    key,
    value
  }
}



const startCancelProject = buildAsyncAction(
  POST_CANCEL_PROJECT,
  POST_CANCEL_PROJECT_START,
  [POST_CANCEL_PROJECT_SUCCESS, POST_CANCEL_PROJECT_ERROR]
)
const postCancelProject = () => ({ type: POST_CANCEL_PROJECT })
const postCancelProjectStart = () => ({ type: POST_CANCEL_PROJECT_START })
const postCancelProjectSuccess = () => ({ type: POST_CANCEL_PROJECT_SUCCESS })
const postCancelProjectError = (error) => ({ type: POST_CANCEL_PROJECT_ERROR, error })

const scrollTop = (isTop) => ({ type: SCROLL_TOP, isTop })

const getProjectInfo = (projectId) => {
  return dispatch => {
    return dispatch(getProjectDetails(projectId))
      .then(() => dispatch(getWorkflowDetails()))
  }
}

const getProjectDetails = (projectId) => {
  return dispatch => {
    return dispatch(getDetailsAction(projectId))
      .then(data => normalize(data))
      .then(data => dispatch(updateTables(data)))
      .then(data => {
        const { result } = data
        const entries = Object.entries(result)

        if (entries.length !== 1)
          throw 'Project Details doesn\'t return the correct object'

        const info = entries.reduce(
          (result, [key, value]) => ({ key, value }),
          null
        )

        dispatch(updateProjectInfo(info))
        return data
      })
      .catch(e => dispatch(error('Failed to get project details.')))
  }
}

const getWorkflowDetails = () => {
  return (dispatch, getState) => {
    const state = getState()
    const workflowId = workflowIdSelector(state)
    return dispatch(getWorkflowAction(workflowId))
      .then(data => normalize(data))
      .then(data => dispatch(updateTables(data)))
      .then(data => {
        const { result } = data
        const entries = Object.entries(result)

        if (entries.length !== 1)
          throw 'Workflow Details doesn\'t return the correct object'

        const info = entries.reduce(
          (result, [key, value]) => ({ key, value }),
          null
        )

        dispatch(updateProjectWorkflow(info))
        return data
      })
      .catch(e => dispatch(error('Failed to get workflow details.')))
  }
}

const loadFormDataAction = (projectId) => {
  const url = getProjectFormUrl(projectId)
  return dispatch => {
    let promise = Promise.resolve(null)

    dispatch(loadProjectFormData(projectId))
    dispatch(setIsLoaded())

    return promise
  }
}

const loadFormData = asyncReduxFilter(
  LOAD_FORM_DATA,
  loadFormDataAction
)

const cloneProjectFunc = () => {
  return (dispatch, getState) => {
    const state = getState()
    let promise = Promise.resolve(null)
    const productHierarchyId = productHierarchyIdSelector(state)
    const productClassId = productClassTypeIdSelector(state)
    const partnerSiteId = partnerSiteIdSelector(state)
    const scheduleInfo = projectScheduleSelector(state)

    if (partnerSiteId && productHierarchyId) {
      dispatch(setFormStatus(FORM_STATUS.CLONE))
      dispatch(setRedirect(true))
      promise = dispatch(createProjectAction(productHierarchyId, partnerSiteId, productClassId, scheduleInfo))
        .then(projectId => dispatch(getProjectInfoAction(projectId)))
    }

    return promise
  }
}

const cloneProject = asyncReduxFilter(CLONE_PROJECT, cloneProjectFunc)

const initialize = () => {
  return dispatch => {
    return dispatch(setFormStatus(FORM_STATUS.VIEW))
  }
}

export {
  initialize,
  cloneProject,
  loadFormData,
  getProjectInfo,
  getWorkflowDetails,
  getProjectDetails,
  toggleCollapse,
  clearProjectInfo,
  postCancelProject,
  postCancelProjectStart,
  postCancelProjectSuccess,
  postCancelProjectError,
  scrollTop,
  startCancelProject,
}
